@if (show) {
    <span class="dvb-spinner">
        <i class="fa fa-circle-o-notch fa-spin"></i>
    </span>
}
